var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9987 6.66683C16.745 6.66683 13.7456 6.93517 11.3382 7.25312C9.17157 7.53927 7.53781 9.17304 7.25166 11.3397C6.93371 13.7471 6.66536 16.7464 6.66536 20.0002C6.66536 23.2539 6.93371 26.2532 7.25166 28.6607C7.53781 30.8273 9.17157 32.4611 11.3382 32.7472C13.7456 33.0652 16.745 33.3335 19.9987 33.3335C23.2524 33.3335 26.2518 33.0652 28.6592 32.7472C30.8258 32.4611 32.4596 30.8273 32.7457 28.6607C33.0637 26.2532 33.332 23.2539 33.332 20.0002C33.332 16.7464 33.0637 13.7471 32.7457 11.3397C32.4596 9.17304 30.8258 7.53927 28.6592 7.25312C26.2518 6.93517 23.2524 6.66683 19.9987 6.66683ZM10.9018 3.94848C7.24044 4.43204 4.43057 7.2419 3.94702 10.9032C3.61459 13.4203 3.33203 16.569 3.33203 20.0002C3.33203 23.4314 3.61459 26.58 3.94702 29.0971C4.43057 32.7584 7.24044 35.5683 10.9018 36.0518C13.4188 36.3843 16.5675 36.6668 19.9987 36.6668C23.4299 36.6668 26.5786 36.3843 29.0956 36.0518C32.757 35.5683 35.5668 32.7584 36.0504 29.0971C36.3828 26.58 36.6654 23.4314 36.6654 20.0002C36.6654 16.569 36.3828 13.4203 36.0504 10.9032C35.5668 7.2419 32.757 4.43204 29.0956 3.94848C26.5786 3.61605 23.4299 3.3335 19.9987 3.3335C16.5675 3.3335 13.4188 3.61605 10.9018 3.94848Z",
    fill: "#141416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 21.6668C12.4142 21.6668 11.668 20.9206 11.668 20.0002C11.668 19.0797 12.4142 18.3335 13.3346 18.3335H26.668C27.5884 18.3335 28.3346 19.0797 28.3346 20.0002C28.3346 20.9206 27.5884 21.6668 26.668 21.6668H13.3346Z",
    fill: "#141416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSquare);
export default __webpack_public_path__ + "static/media/minus-square.54ba6eed733ba81228bae458963f64e6.svg";
export { ForwardRef as ReactComponent };